import { render, staticRenderFns } from "./PT620DairiOrderHisParts.vue?vue&type=template&id=66b3209a&"
import script from "./PT620DairiOrderHisParts.vue?vue&type=script&lang=js&"
export * from "./PT620DairiOrderHisParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports